export default __webpack_public_path__ + "static/media/missions_green.d6d3c03b.png";